import { isDevelopment } from "../core/env.js";
import { getCurrentResourceFiber } from "../core/execution-context.js";
import { tapRef } from "./tap-ref.js";
import { depsShallowEqual } from "./utils/depsShallowEqual.js";
export const tapMemo = (fn, deps) => {
    const dataRef = tapRef();
    if (!dataRef.current) {
        if (isDevelopment) {
            const fiber = getCurrentResourceFiber();
            if (fiber.devStrictMode) {
                void fn();
            }
        }
        dataRef.current = { value: fn(), deps };
    }
    if (!depsShallowEqual(dataRef.current.deps, deps)) {
        dataRef.current.value = fn();
        dataRef.current.deps = deps;
    }
    return dataRef.current.value;
};
//# sourceMappingURL=tap-memo.js.map